import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { cloneDeep } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import {
  CHILD_NAME_EMPTY,
  CHILD_NAME_ERROR,
  PRICE_ERROR,
  CHILD_SAVE_SUCCESS,
  CHILD_EXIST_ERROR,
  ERROR,
  ROUTES,
  SCENARIO_BUILDER_CONSTS,
  PERIOD_DATA,
  STATIC_KEYS,
  STATIC_DISPLAY_KEYS,
  MPI_MONTH_MAPPER2,
  PERIOD_COLS_INDEX,
  REGION_LEADER,
  PRICE_CHANGE_MAPPER,
} from '../../shared/shared-config';
import { Papa } from 'ngx-papaparse';
import { errorOrSuccessPopup } from '../../../helper/utilities';
import { FilterRecorderService } from 'src/services/filter-recorder.service';
import { PriceScenarioService } from 'src/services/priceScenario.service';
import { DataService } from 'src/app/data.service';
import { CONFIG } from 'src/helper/app-config';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

import { ConsistencyCheckComponent } from '../consistency-check/consistency-check.component';
// import { FilterRecorderService } from 'src/app/services/filter-recorder.service';
// import { PopupComponent } from 'src/app/shared-components/popup/popup.component';
/**
 *
 * This component is responsible for creating Child Scenarios
 * @component ScenarioBuilderComponent
 */
@Component({
  selector: 'app-scenario-builder',
  standalone: false,
  templateUrl: './scenario-builder.component.html',
  styleUrls: ['./scenario-builder.component.scss'],
})
export class ScenarioBuilderComponent implements OnInit {
  KEYS_OF_CSV = SCENARIO_BUILDER_CONSTS;
  @ViewChild(MatTable, { read: ElementRef }) private matTableRef!: ElementRef;
  demoniation = 0;
  dynamicFilterLoading: boolean = false;
  inflation: any;
  private gridApi: any;
  priceArray: any = new Array();
  currentPrice: any;
  newPrice: any;
  percentPrice: any;
  filtersActive: any = new Array();
  columnDefs: any;
  defaultColDef: any;
  columnTypes: any;
  childScenarioTableData: any;
  availableKeys: any;
  filter_details: any = {};
  permanentData: any;
  rowClassRules: any;
  enableRun: boolean = true;
  frameworkComponents: any;
  undoRedoCellEditingLimit: any;
  selected: string = 'Brand';
  levels: any = new Array();
  allColumnFilters: any;
  leveldatas: any;
  private levelRemainder: any = 'Brand';
  overallCurrentPr: number = 0;
  overallNewPr: number = 0;
  overallCurrentPrCal: number = 0;
  overallNewPrCal: number = 0;
  overallPercentPr: number = 0;
  overallCurrentPrice: number = 0;
  overallNewPrice: number = 0;
  updated_value: number = 0;
  customUndoStack: any = new Array();
  customRedoStack: any = new Array();
  undoStack: any = [];
  redoStack: any = [];
  absolute: any = 0;
  percent: any = 0;
  scenarioP: any = new Array();
  undoSize: any = 1;
  redoSize: any = 0;
  indexDecider: any = new Array();
  directEdit: number = 0;
  model: any;
  lastCalledFunction: any = 0;
  originalRowData: any;
  columnData: any;
  baseScenarioName: any;
  childScenarioName: any;
  childScenarioNameCollection: any = new Array();
  selectedChannel: any;
  currentBaseScenario: any;
  disabledit: any = false;
  loading = true;
  saving = false;
  warn = 'warn';
  loggedIn: any;
  prevModel: any = {};
  firstLoading: any = true;
  base = false;
  child = false;
  scenarioNameToSave: any;
  timePeriod: any;
  comingFrom: any;
  negCheck = false;
  filteredArray: any = [];
  selectedValue: string;
  conversionDictionary: any = {
    Retailer: 'retailer',
    Manufacturer: 'Manufacturer',
    'Price Sector': 'PriceSector',
    'Pack Size Bucket': 'LengthBand',
    'Pack Size': 'PackContents',
    Brand: 'BrandHouse',
    'Sub Brand': 'BrandVariant',
    'SKU Description': 'BrandPackVariant',
    'Base Price': 'Base_Price',
    'Lead Amount': 'Lead Amount',
    Base_Units: 'Base_Units',
  };

  columns: any[] = [
    { field: [STATIC_KEYS.RETAILER], width: 100 },
    { field: [STATIC_KEYS.PRICE_SECTOR], width: 100 },
    { field: [STATIC_KEYS.BRAND], width: 100 },
    { field: [STATIC_KEYS.TAR_LEVEL], width: 100 },
    { field: [STATIC_KEYS.BRAND_PACK_VARIANT], width: 100 },
    { field: [STATIC_KEYS.LENGTH_BAND], width: 100 },
    { field: [STATIC_KEYS.PACK_CONTENTS], width: 100 },
    { field: [STATIC_KEYS.MANFACTURER], width: 100 },
  ];

  columnDictionary: any = {
    [STATIC_KEYS.RETAILER]: 'Retailer',
    [STATIC_KEYS.MANFACTURER]: 'Manufacturer',
    [STATIC_KEYS.PRICE_SECTOR]: 'Price Sector',
    [STATIC_KEYS.LENGTH_BAND]: 'Pack Size Bucket',
    [STATIC_KEYS.PACK_CONTENTS]: 'Pack Size',
    [STATIC_KEYS.BRAND_HOUSE]: 'Brand',
    [STATIC_KEYS.BRAND_VARIANT]: 'Sub Brand',
    [STATIC_KEYS.BRAND_PACK_VARIANT]: 'SKU Description',
    [STATIC_KEYS.BASE_PRICE]: 'Base Price',
    [STATIC_KEYS.BRAND]: 'Brand',
    'Lead Amount': 'Lead Amount',
  };
  childKeyForMeta: any;
  country: any;
  countryView: any = '';
  tableColumns: any = [];
  dataSource: any;
  columnWidths: any = {
    [STATIC_DISPLAY_KEYS.RETAILER]: 100,
    [STATIC_DISPLAY_KEYS.PRICE_SECTOR]: 100,
    [STATIC_DISPLAY_KEYS.BRAND_HOUSE]: 120,
    [STATIC_DISPLAY_KEYS.TAR_LEVEL]: 70,
    [STATIC_DISPLAY_KEYS.BRAND_PACK_VARIANT]: 180,
    [STATIC_DISPLAY_KEYS.BASE_PRICE]: 70,
    [STATIC_DISPLAY_KEYS.PACK_CONTENTS]: 120,
    [STATIC_DISPLAY_KEYS.LENGTH_BAND]: 120,
    [STATIC_DISPLAY_KEYS.MANFACTURER]: 70,
    [STATIC_DISPLAY_KEYS.BRAND_VARIANT]: 120,
  };
  testWidth = 200;
  token = '';
  retailerListOrg: any;
  updatedRows: any = [];
  selectedFilterColumn = '';
  columnFilters: any = {};
  appliedFilters: any = {};
  actualRowData: any;
  actualRowDataForFiltering: any;
  allSelected: any = {};
  actualColumnfilters: any;
  selectedMode: any;
  selectedScenarioType: any;
  currentPath: any;
  comments: string;
  prev_selected_filters: any;
  stringCols = [];
  numCols = [];
  displayedColumns: string[] = [];
  pressed = false;
  currentResizeIndex: number = 0;
  startX: number = 0;
  startWidth: number = 0;
  isResizingRight: boolean = false;
  resizableMousemove: any;
  resizableMouseup: any;
  isDownloadLoading: boolean = false;
  isUploadLoading: boolean = false;
  orderOfPriceScenarioTableCols = [
    STATIC_KEYS.RETAILER,
    REGION_LEADER,
    STATIC_KEYS.MANFACTURER,
    STATIC_KEYS.PRICE_SECTOR,
    STATIC_KEYS.BRAND_HOUSE,
    STATIC_KEYS.BRAND_VARIANT,
    STATIC_KEYS.BRAND_PACK_VARIANT,
    STATIC_KEYS.PACK_CONTENTS,
    STATIC_KEYS.LENGTH_BAND,
    STATIC_KEYS.TAR_LEVEL,
  ];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild('inputSearch', { static: false }) inputSearch: ElementRef;
  periodMapper = {
    week: '-W',
    month: '-M',
    quarter: '-Q',
  };
  monthsMapper = MPI_MONTH_MAPPER2;
  isFileUpload = false;

  constructor(
    private papa: Papa,
    private filterRecorderService: FilterRecorderService,
    private priceScenarioService: PriceScenarioService,
    private router: Router,
    private renderer: Renderer2,
    public dialog: MatDialog,
    private dataService: DataService,
    private route: ActivatedRoute,
  ) {
    // this.tableColumns = Object.keys(this.columnWidths)
  }
  yearWiseWeeksCols = {};
  periodType = '';
  baseDetails: any = {};
  is_show_loader = true;
  childScenarioUpdatedData = [];
  regionLeader = REGION_LEADER;
  retailer = STATIC_DISPLAY_KEYS.RETAILER;
  options: string[] = [
    'Pack Upsize/Downsize',
    'New Product Launch',
    'Pack Merger',
    'Pack Split',
  ];

  selectedOption: string | null = null;
  downloaded = false;
  downloadedFileContent: any[] = [];

  ngOnInit() {
    this.priceScenarioService.setCurrentScreen('Builder');
    this.selectedChannel = this.priceScenarioService.getSelectedChannel();
    this.filterRecorderService.clearUndoStack();
    this.customRedoStack = [];
    let path = this.priceScenarioService.getPath() || 'addChildScenario';
    this.currentPath = cloneDeep(path);
    this.comingFrom = this.priceScenarioService.getPath();
    this.selectedChannel = this.priceScenarioService.getSelectedChannel();
    this.currentBaseScenario = this.priceScenarioService.getCurrentScenario();
    this.baseScenarioName = this.priceScenarioService.getCurrentScenario();
    this.route.queryParams?.subscribe((params) => {
      this.baseDetails = params?.['baseDetails'];
      if (this.baseDetails) {
        this.baseDetails = JSON.parse(this.baseDetails);
        this.baseScenarioName = this.baseDetails.base_scenario_name;
      }
      if (path == 'addChildScenario') {
        let payload = {
          base_scenario_name: this.baseScenarioName,
          edit_scenario_flag: true,
          pc_input_flag: this.isFileUpload ? 1 : 0,
        };
        this.dataService
          .postRequest(payload, CONFIG.API2.CHILD_BASE_DATA_TEMPLATE)
          .then((response) => {
            this.loading = false;
            if (response['data']) {
              this.base = false;
              this.periodType = response['period_type'];
              Object.keys(response['data'][0][PERIOD_DATA]).map((yearKey) => {
                const resultArray = [];

                for (const o of response['data'][0][PERIOD_DATA][yearKey]) {
                  const key = Object.keys(o)[0];
                  resultArray.push(key);
                }

                this.yearWiseWeeksCols[yearKey] = resultArray;
              });
              response['data'] = this.createWeeksColumns(response['data']);
              this.tableColumns = Object.keys(response['data'][0]);
              this.tableColumns = this.tableColumns.filter((col) => {
                return (
                  col != PERIOD_DATA &&
                  col != 'period_type' &&
                  col != STATIC_KEYS.VOLUME
                );
              });

              this.tableColumns = this.sortYearWise(this.tableColumns);
              this.tableColumns = this.sortArrByOrder(
                this.tableColumns,
                this.orderOfPriceScenarioTableCols,
              );
              let diffCols = this.separateStringsAndNumbers(this.tableColumns);
              this.stringCols = diffCols.strings;
              this.numCols = diffCols.numbers;
              this.childScenarioTableData = response['data'];

              this.timePeriod = this.childScenarioTableData[1]['period'];
              this.demoniation = 0;
              this.inflation = 0;
              for (let i = 0; i < this.childScenarioTableData.length; i++) {
                this.childScenarioTableData[i]['id'] = i;
                this.filteredArray.push(i);
                this.scenarioP.push(
                  this.childScenarioTableData[i]['scenario_price'],
                );
              }

              Object.keys(this.childScenarioTableData[0]).forEach((key) => {
                if (key == 'InternalPe' || key == 'ExternalPe') {
                } else {
                  this.columnFilters[key] = Array.from(
                    new Set(
                      this.childScenarioTableData.map((row: any) => row[key]),
                    ),
                  );
                  this.allSelected[key] = true;
                  this.columnFilters[key].sort();
                }
              });
              this.permanentData = cloneDeep(this.childScenarioTableData);

              this.columnFilters = this.applyRequiredFilters(
                this.columnFilters,
              );
              this.appliedFilters = cloneDeep(this.columnFilters);
              this.actualColumnfilters = cloneDeep(this.columnFilters);
              this.prev_selected_filters = cloneDeep(this.columnFilters);
              this.actualRowData = cloneDeep(this.childScenarioTableData);

              setTimeout(() => {
                this.dataSource = new MatTableDataSource(
                  this.childScenarioTableData,
                );
                this.dataSource.paginator = this.paginator;
              }, 0);

              let keys = [
                STATIC_KEYS.RETAILER,
                STATIC_KEYS.BRAND_HOUSE,
                STATIC_KEYS.BRAND_VARIANT,
                STATIC_KEYS.BRAND_PACK_VARIANT,
                STATIC_KEYS.LENGTH_BAND,
                STATIC_KEYS.MANFACTURER,
                STATIC_KEYS.PRICE_SECTOR,
                STATIC_KEYS.PACK_CONTENTS,
                'Lead Amount',
              ];

              this.levels = keys.map((item) => {
                return {
                  name: this.columnDictionary[item],
                  value: item,
                  selected: false,
                };
              });

              this.selectedValue = this.levels[0].value;
              this.levels[0].selected = true;
              this.changeLevel(this.selectedValue);
              this.selected = this.levels[0].name;
              this.changeOverAll();
            } else {
              errorOrSuccessPopup(ERROR, '', 'warning');
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (path == 'loadChildScenario') {
        this.child = true;
        this.selectedScenarioType =
          this.priceScenarioService.getCurrentChildScenarioVersion();
        let child = this.priceScenarioService.getCurrentChildScenario();
        this.childScenarioName = child;
        this.disabledit = true;
        // this.priceScenarioService
        //   .loadChildScenario(
        //     false,
        //     this.baseScenarioName,
        //     this.selectedChannel,
        //     this.childScenarioName
        //   )
        //   .subscribe({
        //     next: (response: any) => {
        //       if (response["data"]) {
        //         // console.log("loadscenario", response);
        //         this.loading = false;
        //         this.base = false;
        //         this.childScenarioTableData = response["data"];
        //         this.permanentData = cloneDeep(response["data"]);
        //         this.timePeriod = this.childScenarioTableData[1]["period"];
        //         this.demoniation = 0;
        //         this.inflation = 0;
        //         this.comments = response["scenario_details"]["comments"];
        //         console.log("data,", this.childScenarioTableData);
        //         for (let i = 0; i < this.childScenarioTableData.length; i++) {
        //           this.childScenarioTableData[i]["id"] = i;
        //           this.filteredArray.push(i);
        //           this.scenarioP.push(
        //             this.childScenarioTableData[i]["scenario_price"]
        //           );
        //         }
        //         Object.keys(this.childScenarioTableData[0]).forEach((key) => {
        //           if (key == "InternalPe" || key == "ExternalPe") {
        //           } else {
        //             this.columnFilters[key] = Array.from(
        //               new Set(
        //                 this.childScenarioTableData.map((row: any) => row[key])
        //               )
        //             );
        //             this.allSelected[key] = true;
        //           }
        //         });
        //         this.appliedFilters = cloneDeep(this.columnFilters);
        //         this.actualColumnfilters = cloneDeep(this.columnFilters);
        //         this.actualRowData = cloneDeep(this.childScenarioTableData);
        //         this.prev_selected_filters = cloneDeep(this.columnFilters);
        //         setTimeout(() => {
        //           this.dataSource = new MatTableDataSource(
        //             this.childScenarioTableData
        //           );
        //           this.dataSource.paginator = this.paginator;
        //         }, 0);
        //         // let keys = Object.keys(this.childScenarioTableData[0]);
        //         let keys = ["brand", "line_mapped", "product_category"];
        //         this.levels = keys.map((item) => {
        //           return {
        //             name: this.toCapitalize(item),
        //             value: item,
        //             selected: false,
        //           };
        //         });
        //         // this.changeLevel("Brand");
        //         this.selectedValue = this.levels[0].value;
        //         this.levels[0].selected = true;
        //         this.changeLevel(this.selectedValue);
        //         this.selected = this.levels[0].name;
        //         this.changeOverAll();
        //       } else {
        //         errorOrSuccessPopup(ERROR, "", "warning");
        //       }
        //     },
        //     error: (err: any) => {
        //       errorOrSuccessPopup(ERROR, "", "warning");
        //     },
        //   });
      }
    });

    this.setDisplayedColumns();
  }
  applyRequiredFilters(obj) {
    let requiredFilters = [
      STATIC_KEYS.BRAND_HOUSE,
      STATIC_KEYS.BRAND_PACK_VARIANT,
      STATIC_KEYS.PRICE_SECTOR,
      // STATIC_KEYS.TAR_LEVEL,
      STATIC_KEYS.RETAILER,
      STATIC_KEYS.LENGTH_BAND,
      STATIC_KEYS.PACK_CONTENTS,
      STATIC_KEYS.MANFACTURER,
      STATIC_KEYS.BRAND_VARIANT,
      'Lead Amount',
    ];
    let keys = Object.keys(obj);
    keys.map((key) => {
      if (!requiredFilters.includes(key)) {
        delete obj[key];
      }
    });
    return obj;
  }
  format() {
    this.absolute = parseFloat(this.absolute.toFixed(2));
  }
  sortYearWise(arr) {
    return arr.sort(function (a, b) {
      // Check if both elements are numbers
      const isANumber = !isNaN(a);
      const isBNumber = !isNaN(b);

      // Compare based on whether they are numbers or not
      if (isANumber && isBNumber) {
        return a - b; // If both are numbers, sort them numerically
      } else if (isANumber) {
        return 1; // If only 'a' is a number, move it to the end
      } else if (isBNumber) {
        return -1; // If only 'b' is a number, move it to the end
      } else {
        return 0; // If neither is a number, maintain their order
      }
    });
  }
  separateStringsAndNumbers(inputArray) {
    const stringArray = [];
    const numberArray = [];

    inputArray.forEach((item) => {
      if (!this.isNumber(item)) {
        stringArray.push(item);
      } else if (this.isNumber(item)) {
        numberArray.push(item);
      }
      // You can add more conditions for other data types if needed
    });

    return { strings: stringArray, numbers: numberArray };
  }
  openDialog(data) {
    const dialogRef = this.dialog.open(ConsistencyCheckComponent, {
      // width: '400px',
      data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }
  changeLevel(levelValue: any) {
    this.selectedValue = levelValue;
    this.levelRemainder = levelValue;
    let uniqueSelectedLevelVals = [
      ...new Set(this.actualRowData.map((obj) => obj[levelValue])),
    ];
    this.priceArray = uniqueSelectedLevelVals.map((level: string) => {
      let filteredLevelObjs = this.actualRowData.filter((obj) => {
        return obj[levelValue] === level;
      });
      const sumOfVolume = filteredLevelObjs.reduce(
        (accumulator, currentValue) => {
          return accumulator + Number(currentValue[STATIC_KEYS.VOLUME]);
        },
        0,
      );
      let volXBasePrice = this.calculateVolumeXBasePrice(filteredLevelObjs);
      let currentPrice = volXBasePrice / sumOfVolume;
      if (volXBasePrice == 0) {
        currentPrice = 0;
      }
      let volXLatestPrice =
        this.findLatestPeriodDataAndCalculateVolumeXLatestPrice(
          filteredLevelObjs,
        );

      let newPrice =
        this.findLatestPeriodDataAndCalculateVolumeXLatestPrice(
          filteredLevelObjs,
        ) / sumOfVolume;

      if (volXLatestPrice == 0) {
        newPrice = 0;
      }
      return {
        levelValueData: level,
        currentPrice,
        newPrice,
        percentPrice: this.calculatePercentageIncrease(newPrice, currentPrice),
      };
    });
  }
  calculateVolumeXBasePrice(data) {
    let totalValue = 0;

    // Loop through the array and calculate the total value
    for (let i = 0; i < data.length; i++) {
      const row = data[i];
      totalValue +=
        Number(row[STATIC_KEYS.BASE_PRICE]) * Number(row[STATIC_KEYS.VOLUME]);
    }

    return totalValue;
  }
  calculatePercentageIncrease(newPrice, currentPrice) {
    let value = ((newPrice - currentPrice) / currentPrice) * 100;
    if (isNaN(value)) {
      return 0;
    }
    return value;
  }
  findLatestPeriodDataAndCalculateVolumeXLatestPrice(data) {
    const latestPeriodData = data.map((item) => {
      const latestYear = Math.max(...Object.keys(item.period_data).map(Number));
      const latestYearData = item.period_data[latestYear];
      let latestPeriod = latestYearData[0];

      for (const period of latestYearData) {
        const periodNumber = parseInt(Object.keys(period)[0]);
        const latestPeriodNumber = parseInt(Object.keys(latestPeriod)[0]);

        if (periodNumber > latestPeriodNumber) {
          latestPeriod = period;
        }
      }
      let key = Object.keys(latestPeriod);
      let value = latestPeriod[key[0]];
      return { ...item, periodValue: value };
    });

    let totalValue = 0;

    // Loop through the array and calculate the total value
    for (let i = 0; i < latestPeriodData.length; i++) {
      const row = latestPeriodData[i];
      totalValue +=
        Number(row['periodValue']) * Number(row[STATIC_KEYS.VOLUME]);
    }

    return totalValue;
    // console.log(latestPeriodData);
    // return latestPeriodData;
  }
  sortArrByOrder(inputArray, orderArray) {
    // Create a map to store the index of each element in the order array
    const orderMap = new Map();
    orderArray.forEach((element, index) => {
      orderMap.set(element, index);
    });

    // Custom sorting function
    inputArray.sort((a, b) => {
      const indexA = orderMap.has(a) ? orderMap.get(a) : Infinity;
      const indexB = orderMap.has(b) ? orderMap.get(b) : Infinity;

      return indexA - indexB;
    });

    return inputArray;
  }
  createWeeksColumns(data) {
    data = data.map((obj) => {
      let yearKeys = Object.keys(obj[PERIOD_DATA]);

      yearKeys.forEach((yearKey) => {
        // obj.period_data[yearKey].map((weekObj)=>{
        // obj[`year_${yearKey}_week_${weekObj.week}`] = weekObj.value
        // })
        obj[yearKey] = '';
      });
      return obj;
    });

    return data;
  }

  isNumber(value) {
    // Use a regular expression to check if the value is a number
    return /^\d+$/.test(value);
  }
  createFlatKeyValues(tableData, deleteVolume?) {
    let finalData = [];
    tableData.map((obj) => {
      let temp = deleteVolume
        ? { ...obj }
        : {
            Retailer: obj['retailer'],
            Manufacturer: obj['Manufacturer'],
            'Price Sector': obj['PriceSector'],
            'Pack Size Bucket': obj['LengthBand'],
            'Pack Size': obj['PackContents'],
            Brand: obj['BrandHouse'],
            'Sub Brand': obj['BrandVariant'],
            'SKU Description': obj['BrandPackVariant'],
            'Base Price': obj['Base_Price'],
            'Lead Amount': obj['Lead Amount'],
            id: obj.id,
            period_data: obj['period_data'],
            Base_Units: obj['Base_Units'],
          };

      let yearKeys = Object.keys(obj[PERIOD_DATA]);
      yearKeys.map((yearKey) => {
        temp = this.removeNumberKeys(temp);
        obj[PERIOD_DATA][yearKey].map((periodDataObj) => {
          let keys = Object.keys(periodDataObj);
          keys.map((key) => {
            temp[`${yearKey}${this.periodMapper[this.periodType]}${key}`] =
              periodDataObj[key];
          });
        });
      });
      delete temp.id;
      delete temp[PERIOD_DATA];
      if (deleteVolume) {
        delete temp[STATIC_KEYS.VOLUME];
      }
      finalData.push(temp);
    });
    return finalData;
  }

  removeNumberKeys(obj) {
    let keys = Object.keys(obj);
    keys.map((key) => {
      if (this.isNumber(key)) {
        delete obj[key];
      }
    });
    return obj;
  }
  addRequiredCols(obj) {
    let yearKeys = Object.keys(this.yearWiseWeeksCols);
    yearKeys.map((year) => {
      this.yearWiseWeeksCols[year].map((col) => {
        obj[col] = 0;
      });
    });
    return obj;
  }
  testLoading = true;
  saveChild() {
    if (!this.childScenarioName) {
      Swal.fire({
        text: 'Please Enter Price Scenario Name!',
        icon: 'warning',
        confirmButtonColor: '#25d4cf',
        confirmButtonText: 'OK',
      });
      return;
    }

    if (this.childScenarioName.length > 30) {
      Swal.fire({
        text: 'Price Scenario Name should be less than 30 chars.',
        icon: 'warning',
        confirmButtonColor: '#25d4cf',
        confirmButtonText: 'OK',
      });
      return;
    }
    this.loading = true;
    let finalData = this.createFlatKeyValues(this.actualRowData, true);
    const { username, email } =
      this.dataService.getUserDeatailsForScenarioSave();
    const csv = this.papa.unparse(finalData);
    let payload = {
      data: csv,
      base_scenario_name: this.baseScenarioName,
      child_scenario_name: this.childScenarioName,
      username: username,
      user_id: email,
      pc_input_flag: this.isFileUpload ? 1 : 0,
    };
    let uniQuenessPayload = {
      base_scenario_name: this.baseScenarioName,
      child_scenario_name: this.childScenarioName,
    };
    this.dataService
      .postRequest(uniQuenessPayload, CONFIG.API2.CHILD_UNIQUENESS)
      .then((res) => {
        if (res['msg'] === 'unique scenario name') {
          this.dataService
            .postRequest(payload, CONFIG.API2.SAVE_CHILD)
            .then((response: any) => {
              this.loading = false;
              if ((response.status = 'processing')) {
                Swal.fire({
                  icon: 'success',
                  html: this.childScenarioName + CHILD_SAVE_SUCCESS,
                  showConfirmButton: false,
                  timer: 2000,
                });
                setTimeout(() => {
                  this.router.navigate(['/library']);
                }, 2500);
              } else {
                Swal.fire({
                  text: ERROR,
                  icon: 'warning',
                  confirmButtonColor: '#d31346',
                  confirmButtonText: 'OK',
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
              Swal.fire({
                text: ERROR,
                icon: 'warning',
                confirmButtonColor: '#d31346',
                confirmButtonText: 'OK',
              });
            });
        } else {
          this.loading = false;
          errorOrSuccessPopup(
            this.childScenarioName,
            '' + CHILD_EXIST_ERROR,
            'warning',
            3000,
          );
          this.saving = false;
        }
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
        Swal.fire({
          icon: 'warning',
          html: this.childScenarioName + CHILD_EXIST_ERROR,
          showConfirmButton: false,
          timer: 3000,
        });
      });
  }
  findUniqueRetailers(list) {
    const uniqueRetailers = new Set(
      list.map((item) => item[STATIC_KEYS.RETAILER]),
    );
    return [...uniqueRetailers];
  }
  downloadCSV() {
    let finalData = this.createFlatKeyValues(this.dataSource.data, false);
    this.downloadCSVFile(finalData);
  }
  downloadCSVFile(jsonData) {
    this.retailerListOrg = this.findUniqueRetailers(jsonData);
    if (this.baseDetails['price'] == PRICE_CHANGE_MAPPER.POST_CODE_PLAN) {
      jsonData = jsonData.map((obj) => {
        obj[REGION_LEADER] = obj[STATIC_KEYS.RETAILER];
        delete obj[STATIC_KEYS.RETAILER];
        return obj;
      });
    }
    this.columnData = Object.keys(jsonData[0]);
    // this.columnData = this.columnData.map((col)=>{
    //   if(col==STATIC_KEYS.RETAILER){
    //     return REGION_LEADER
    //   }
    // })
    const csv = this.papa.unparse(jsonData, {
      columns: this.sortArrByOrder(
        this.columnData,
        this.orderOfPriceScenarioTableCols,
      ),
    });
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'basedata.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  changeOverAll() {
    let overallProductCurr = 0;
    let overallProductNew = 0;

    let pack_size = 0;
    let value = 0;
    let updated_value = 0;

    let sumOfUpdatedValue = 0;
    if (false) {
      this.gridApi.forEachNode(function (rowNode: any) {
        if (rowNode.data['sku'] != 1) {
          overallProductCurr +=
            rowNode.data['price_per_unit'] * rowNode.data['volume'];
          overallProductNew +=
            rowNode.data['scenario_price'] * rowNode.data['volume'];

          pack_size += rowNode.data['volume'];
        }
      });
    } else {
      this.priceArray.map((item: any) => {
        value += item.value;
        updated_value += item.updated_value;
        pack_size += item.volume;
        // overallProductCurr += Number.parseFloat(item.currentPrice)
        // overallProductNew += Number.parseFloat(item.newPrice)
      });
      for (let i = 0; i < this.actualRowData.length; i++) {
        overallProductCurr +=
          this.actualRowData[i][this.KEYS_OF_CSV.BASE_PRICE] *
          this.actualRowData[i]['volume'];
        overallProductNew +=
          this.actualRowData[i]['scenario_price'] *
          this.actualRowData[i]['volume'];
        // pack_size += this.actualRowData[i]["volume"];
      }
    }
    this.overallCurrentPrice = value / pack_size;
    this.overallNewPrice = updated_value / pack_size;
    // this.overallPercentPr= 0;
    this.overallCurrentPrCal = overallProductCurr / pack_size;
    // this.overallCurrentPr = Math.round(overallProductCurr / pack_size);
    // console.log("overallCurrentPr",overallProductCurr,pack_size);
    this.overallNewPrCal = overallProductNew / pack_size;
    // this.overallNewPr = Math.round(overallProductNew / pack_size);
    this.overallPercentPr = Math.round(
      ((this.overallNewPrCal - this.overallCurrentPrCal) /
        this.overallCurrentPrCal) *
        100,
    );
  }
  removeUndefinedKeyValues(obj) {
    for (const key in obj) {
      if (key === undefined || obj[key] === undefined) {
        delete obj[key];
      }
    }
  }

  filterActivity(e: any, removeFilter = '') {
    this.undoSize = this.filterRecorderService.getUndoStackSize();

    if (removeFilter != '') {
      removeFilter = this.conversionDictionary[removeFilter];
      this.filterRecorderService.deleteFilterColumn(removeFilter);
    }
    this.filtersActive = [];
    this.filtersActive = this.filterRecorderService.getActiveFilter();
  }

  undoFilters(model: any = 'none') {
    this.filterRecorderService.updateCurrentModel(model);
    this.lastCalledFunction = 6;
  }

  absolutePriceIncrease(
    absolute: number,
    undoredoCalled = 0,
    prevScenarioP = [],
    model = 'none',
  ) {
    if (absolute > 100000) return;
    this.undoStack.push({
      childScenarioTableData: cloneDeep(this.childScenarioTableData),
      updatedRows: cloneDeep(this.updatedRows),
      actualRowData: cloneDeep(this.actualRowData),
      allSelected: cloneDeep(this.allSelected),
      appliedFilters: cloneDeep(this.appliedFilters),
      previousSelected: cloneDeep(this.prev_selected_filters),
      inflation: cloneDeep(this.inflation),
      demoniation: cloneDeep(this.demoniation),
    });
    if (!undoredoCalled) {
      this.updatedRows = [];
      this.customRedoStack = [];
      this.lastCalledFunction = 2;

      this.childScenarioTableData = this.childScenarioTableData.map(
        (row: any) => {
          // row["scenario_price"] += +absolute;
          let yearKeys = Object.keys(row[PERIOD_DATA]);
          yearKeys.map((yearKey) => {
            row[PERIOD_DATA][yearKey] = row[PERIOD_DATA][yearKey].map(
              (periodObj) => {
                let keys = Object.keys(periodObj);
                keys.map((key) => {
                  periodObj[key] += +absolute;
                });
                return periodObj;
              },
            );
          });
          return row;
        },
      );
      this.filteredArray.forEach((id: any) => {
        // console.log("this.actualRowData[id]", this.actualRowData[id]);
        // this.actualRowData[id]["scenario_price"] = cloneDeep(
        //   parseFloat(this.actualRowData[id]["scenario_price"]) + +absolute
        // );
        // this.actualRowData[id]["percent_change"] = cloneDeep(
        //   Math.round(
        //     ((this.actualRowData[id]["scenario_price"] -
        //       this.actualRowData[id][this.KEYS_OF_CSV.BASE_PRICE]) /
        //       this.actualRowData[id][this.KEYS_OF_CSV.BASE_PRICE]) *
        //       1000
        //   ) / 10
        // );
      });
      this.childScenarioTableData.map((obj) => {
        this.actualRowData[obj['id']] = cloneDeep(obj);
      });
      // this.actualRowData.forEach((element: any) => {
      //   if (element[this.KEYS_OF_CSV.BASE_PRICE] != element["scenario_price"]) {
      //     this.updatedRows.push(element["id"]);
      //   }
      // });
    } else {
      let i = 0;
      this.gridApi.setFilterModel(model);
      this.filtersActive = [];
      this.filtersActive = this.filterRecorderService.getActiveFilter();
      this.gridApi.forEachNode((rowNode: any) => {
        rowNode.setDataValue('scenario_price', prevScenarioP[i++]);
        if (
          rowNode.data[this.KEYS_OF_CSV.BASE_PRICE] !=
          rowNode.data['scenario_price']
        ) {
          rowNode.data.edited = true;
        } else rowNode.data.edited = false;
      });
      this.gridApi.redrawRows();
    }
    this.absolute = absolute;
    this.changeLevel(this.levelRemainder);
    this.changeOverAll();
  }
  //changing in percent column it will operate
  percentagePriceIncrease(
    percent: number,
    undoredoCalled = 0,
    prevScenarioP = [],
    model: any = 'none',
  ) {
    if (percent > 100) return;

    this.undoStack.push({
      childScenarioTableData: cloneDeep(this.childScenarioTableData),
      updatedRows: cloneDeep(this.updatedRows),
      actualRowData: cloneDeep(this.actualRowData),
      allSelected: cloneDeep(this.allSelected),
      appliedFilters: cloneDeep(this.appliedFilters),
      previousSelected: cloneDeep(this.prev_selected_filters),
      inflation: cloneDeep(this.inflation),
      demoniation: cloneDeep(this.demoniation),
    });
    if (!undoredoCalled) {
      this.updatedRows = [];

      this.childScenarioTableData = this.childScenarioTableData.map(
        (row: any) => {
          // row["scenario_price"] =
          //   +(percent * +(row["scenario_price"] * 0.01)) +
          //   +row["scenario_price"];
          // let percent_price_update =
          //   ((row["scenario_price"] - row[this.KEYS_OF_CSV.BASE_PRICE]) /
          //     row[this.KEYS_OF_CSV.BASE_PRICE]) *
          //   100;
          // row["percent_change"] = Math.round(percent_price_update * 10) / 10;
          // row["scenario_price"] = Math.round(row["scenario_price"] * 10) / 10;

          let yearKeys = Object.keys(row[PERIOD_DATA]);
          yearKeys.map((yearKey) => {
            row[PERIOD_DATA][yearKey] = row[PERIOD_DATA][yearKey].map(
              (periodObj) => {
                let keys = Object.keys(periodObj);
                keys.map((key) => {
                  periodObj[key] =
                    periodObj[key] + this.percentageOf(percent, periodObj[key]);
                });
                return periodObj;
              },
            );
          });
          return row;
        },
      );
      this.filteredArray.forEach((id: any) => {
        // this.actualRowData[id]["scenario_price"] =
        //   +(percent * +(this.actualRowData[id]["scenario_price"] * 0.01)) +
        //   +this.actualRowData[id]["scenario_price"];
        // // this.actualRowData[id]["scenario_price"] =
        // //   Math.round(this.actualRowData[id]["scenario_price"] * 10) / 10;
        // this.actualRowData[id]["percent_change"] = cloneDeep(
        //   Math.round(
        //     ((this.actualRowData[id]["scenario_price"] -
        //       this.actualRowData[id][this.KEYS_OF_CSV.BASE_PRICE]) /
        //       this.actualRowData[id][this.KEYS_OF_CSV.BASE_PRICE]) *
        //       1000
        //   ) / 10
        // );
      });

      // this.actualRowData.forEach((element: any) => {
      //   if (element[this.KEYS_OF_CSV.BASE_PRICE] != element["scenario_price"]) {
      //     this.updatedRows.push(element["id"]);
      //   }
      // });
      this.childScenarioTableData.map((obj) => {
        this.actualRowData[obj['id']] = cloneDeep(obj);
      });
    }
    this.changeLevel(this.levelRemainder);
    this.changeOverAll();
  }

  trimSpace() {
    this.childScenarioName = this.childScenarioName.trim();
  }

  checkForSpecialCharacters(name: any) {
    let regex = /^[A-Za-z0-9_]+$/;
    return regex.test(name);
  }

  checkForNegative() {
    this.gridApi.forEachNode((rowNode: any) => {
      if (rowNode.data['scenario_price'] < 0) this.negCheck = true;
    });
  }

  toggleFilterMenu() {
    document.getElementById('myFilterDropdown')!.classList.toggle('show');
    window.onclick = function (event: any) {
      if (
        !event.target.matches('.filterBtn') &&
        !document.getElementById('myFilterDropdown')?.contains(event.target)
      ) {
        var dropdowns = document.getElementsByClassName(
          'dropdown-filter-content',
        );
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    };
  }

  toggleUserInputMenu() {
    document.getElementById('changePriceDropDown')!.classList.toggle('show');
    window.onclick = function (event: any) {
      if (
        !event.target.matches('.dropBtn') &&
        !document.getElementById('changePriceDropDown')?.contains(event.target)
      ) {
        var dropdowns = document.getElementsByClassName('dropdown-content');
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    };
  }

  save(e: any) {
    this.saving = true;
    if (this.inflation == '') this.inflation = 0;
    this.scenarioNameToSave = e;
    let path = this.priceScenarioService.getPath();
    let checkPassed = this.checkForSpecialCharacters(e);
    if (!e.length) {
      errorOrSuccessPopup('', CHILD_NAME_EMPTY, 'warning');
      this.saving = false;
    } else if (!checkPassed) {
      errorOrSuccessPopup('', CHILD_NAME_ERROR, 'warning');
      this.saving = false;
    } else if (this.negCheck) {
      errorOrSuccessPopup('', PRICE_ERROR, 'warning');
      this.saving = false;
      this.negCheck = false;
    } else {
      // //logic
      if (path == 'loadChildScenario') {
        //logic
        let currentDateTime = new Date();
        currentDateTime.setMinutes(currentDateTime.getMinutes() + 30);

        if (this.childScenarioTableData.length < this.actualRowData.length) {
          const addedRows = this.childScenarioTableData.map(
            (row: any) => row['id'],
          );

          let count = 0;
          this.actualRowData.forEach((row: any, i: any) => {
            if (addedRows.includes(row['id'])) {
              this.actualRowData[i] = this.childScenarioTableData[count];
              count++;
            }
          });

          this.childScenarioTableData = cloneDeep(this.actualRowData);
        }
        for (let i = 0; i < this.childScenarioTableData.length; i++) {
          delete this.childScenarioTableData[i]['id'];
        }

        let csvToUpload = this.papa.unparse(this.childScenarioTableData);
        // this.priceScenarioService
        //   .createChildScenario(
        //     this.currentBaseScenario,
        //     e,
        //     this.selectedChannel,
        //     this.comments,
        //     csvToUpload
        //   )
        //   .subscribe({
        //     next: (res: any) => {
        //       if ((res.status = "processing")) {
        //         Swal.fire({
        //           icon: "success",
        //           html: e + CHILD_SAVE_SUCCESS,
        //           showConfirmButton: false,
        //           timer: 2000,
        //         });
        //         this.saving = false;
        //         setTimeout(() => {
        //           this.router.navigate([ROUTES.SCENARIO_LIBRARY]);
        //         }, 2500);
        //       } else {
        //         this.saving = false;
        //         Swal.fire({
        //           text: ERROR,
        //           icon: "warning",
        //           confirmButtonColor: "#d31346",
        //           confirmButtonText: "OK",
        //         });
        //       }
        //     },
        //     error: (err) => {
        //       Swal.fire({
        //         text: ERROR,
        //         icon: "warning",
        //         confirmButtonColor: "#d31346",
        //         confirmButtonText: "OK",
        //       });
        //       this.saving = false;
        //     },
        //   });
      } else {
        // this.priceScenarioService
        //   .childUniquenessChecker(
        //     e,
        //     this.currentBaseScenario,
        //     this.selectedChannel
        //   )
        //   .subscribe({
        //     next: (res: any) => {
        //       if (res["msg"] == "UNIQUE") {
        //         //logic
        //         let currentDateTime = new Date();
        //         currentDateTime.setMinutes(currentDateTime.getMinutes() + 30);
        //         if (
        //           this.childScenarioTableData.length < this.actualRowData.length
        //         ) {
        //           const addedRows = this.childScenarioTableData.map(
        //             (row: any) => row["id"]
        //           );
        //           let count = 0;
        //           this.actualRowData.forEach((row: any, i: any) => {
        //             if (addedRows.includes(row["id"])) {
        //               this.actualRowData[i] =
        //                 this.childScenarioTableData[count];
        //               count++;
        //             }
        //           });
        //           this.childScenarioTableData = cloneDeep(this.actualRowData);
        //         }
        //         for (let i = 0; i < this.childScenarioTableData.length; i++) {
        //           delete this.childScenarioTableData[i]["id"];
        //         }
        //         let csvToUpload = this.papa.unparse(
        //           this.childScenarioTableData
        //         );
        //         let body_for_json;
        //         let childVersion;
        //         if (
        //           path == "loadChildScenario" ||
        //           path == "duplicateChildScenario"
        //         ) {
        //           childVersion = this.selectedScenarioType;
        //         } else {
        //           childVersion = "Exercise";
        //         }
        //         let childCalculationPayload = {
        //           base_scenario_name: this.currentBaseScenario,
        //           child_scenario_name: e,
        //           channel: this.selectedChannel,
        //         };
        //         this.priceScenarioService
        //           .createChildScenario(
        //             this.currentBaseScenario,
        //             e,
        //             this.selectedChannel,
        //             this.comments,
        //             csvToUpload
        //           )
        //           .subscribe({
        //             next: (res: any) => {
        //               if ((res.status = "processing")) {
        //                 Swal.fire({
        //                   icon: "success",
        //                   html: e + CHILD_SAVE_SUCCESS,
        //                   showConfirmButton: false,
        //                   timer: 2000,
        //                 });
        //                 this.saving = false;
        //                 setTimeout(() => {
        //                   this.router.navigate([ROUTES.SCENARIO_LIBRARY]);
        //                 }, 2500);
        //               } else {
        //                 this.saving = false;
        //                 Swal.fire({
        //                   text: ERROR,
        //                   icon: "warning",
        //                   confirmButtonColor: "#d31346",
        //                   confirmButtonText: "OK",
        //                 });
        //               }
        //             },
        //             error: (err) => {
        //               Swal.fire({
        //                 text: ERROR,
        //                 icon: "warning",
        //                 confirmButtonColor: "#d31346",
        //                 confirmButtonText: "OK",
        //               });
        //               this.saving = false;
        //             },
        //           });
        //       } else {
        //         errorOrSuccessPopup("", e + CHILD_EXIST_ERROR, "warning", 3000);
        //         this.saving = false;
        //       }
        //     },
        //     error: (err) => {
        //       Swal.fire({
        //         icon: "warning",
        //         html: e + CHILD_EXIST_ERROR,
        //         showConfirmButton: false,
        //         timer: 3000,
        //       });
        //       this.saving = false;
        //     },
        //   });
      }
    }
  }

  percentageOf(percentage, total) {
    return (percentage / 100) * total;
  }

  runScenario() {
    this.priceScenarioService.setCurrentScenario(this.currentBaseScenario);
    this.priceScenarioService.setCurrentChildScenario(this.childScenarioName);
    this.router.navigate([ROUTES.SCENARIO_OUTPUT]);
  }

  getRoundedData(value: any) {
    return Math.round(value);
  }

  setSelectedFilterColumn(column: any) {
    this.selectedFilterColumn = column;
  }

  applyFilter(event: any, filter: any) {
    this.undoStack.push({
      // name: "childScenarioTableData",
      childScenarioTableData: cloneDeep(this.childScenarioTableData),
      updatedRows: cloneDeep(this.updatedRows),
      actualRowData: cloneDeep(this.actualRowData),
      allSelected: cloneDeep(this.allSelected),
      appliedFilters: cloneDeep(this.appliedFilters),
      previousSelected: cloneDeep(this.prev_selected_filters),
      inflation: cloneDeep(this.inflation),
      demoniation: cloneDeep(this.demoniation),
    });
    event.stopPropagation();

    if (this.appliedFilters[this.selectedFilterColumn]) {
      const filterIndex = this.appliedFilters[
        this.selectedFilterColumn
      ].findIndex((fil: any) => fil === filter);
      if (filterIndex !== -1) {
        this.appliedFilters[this.selectedFilterColumn].splice(filterIndex, 1);
      } else {
        this.appliedFilters[this.selectedFilterColumn].push(filter);
      }
    } else {
      this.appliedFilters[this.selectedFilterColumn] = [filter];
    }
    if (
      this.actualColumnfilters[this.selectedFilterColumn].length >
      this.appliedFilters[this.selectedFilterColumn].length
    ) {
      this.allSelected[this.selectedFilterColumn] = false;
    } else if (
      this.actualColumnfilters[this.selectedFilterColumn].length ==
      this.appliedFilters[this.selectedFilterColumn].length
    ) {
      this.allSelected[this.selectedFilterColumn] = true;
    }

    this.filterData();
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.childScenarioTableData);
      this.dataSource.paginator = this.paginator;
    }, 0);
  }

  checkFilter(filter: any) {
    // console.log("checkFilter",this.appliedFilters)
    return (
      this.appliedFilters[this.selectedFilterColumn] &&
      this.appliedFilters[this.selectedFilterColumn].includes(filter)
    );
  }

  dynamicFilter(onClose?: boolean, disabledKeys?: any) {
    let keysNotToInvlove = [
      'packsize_range',
      'base_contribution_margin',
      'variable_cost_per_kg',
      'contribution_margin_per_kg',
      'net_sales_per_kg',
      'price_elasticity',
      'presentation_desc_en',
      'year',
      'delta_v2',
      'delta_v',
      'prediction_simulated_vol',
      'vol_mix',
      'id',
      'next_price',
      'percent_change',
    ];
    let payload;
    this.dynamicFilterLoading = true;
    if (this.inputSearch && this.inputSearch.nativeElement) {
      this.inputSearch.nativeElement.value = '';
    }

    // this.filter_details[this.selectedFilterColumn]=allFilters.filter((item:any)=>!this.appliedFilters[this.selectedFilterColumn].includes(item))

    if (onClose) {
      this.columnFilters = cloneDeep(this.actualColumnfilters);
      this.availableKeys = Object.keys(this.columnFilters).filter(
        (key) => !keysNotToInvlove.includes(key),
      );
      if (this.appliedFilters[this.selectedFilterColumn] > 0) {
        this.columnFilters[this.selectedFilterColumn].filter((item: any) => {
          this.appliedFilters[this.selectedFilterColumn].includes(item);
        });
      } else {
        this.columnFilters[this.selectedFilterColumn] = cloneDeep(
          this.actualColumnfilters[this.selectedFilterColumn],
        );
      }
      this.filter_details[this.selectedFilterColumn] = cloneDeep(
        this.appliedFilters[this.selectedFilterColumn],
      );
      console.log('keydynamic', this.selectedFilterColumn);
      delete this.filter_details[disabledKeys];

      payload = {
        filter_details: {
          available_keys: this.availableKeys,
          ...this.filter_details,
        },
        // scenarioName: this.baseScenarioName,
        child_scenario_name: this.childScenarioName,
        base_scenario_name: this.baseScenarioName,
        source: 'child-scenario',
        pc_input_flag: this.isFileUpload ? 1 : 0,
      };
      // this.priceScenarioService.dynamicFilter(payload).subscribe({
      //   next: (res: any) => {
      // let available_keys = res["available_keys"];
      // let disabled_keys = onClose ? [] : res["disabled_keys"][0];
      // Object.keys(disabled_keys).forEach((item) => {
      //   available_keys[item] = available_keys[item].concat(
      //     disabled_keys[item]
      //   );
      // });
      // this.columnFilters = cloneDeep(available_keys);
      // console.log("columnFilters2", this.columnFilters);
      // // this.prev_selected_filters = this.appliedFilters
      // this.dynamicFilterLoading = false;
      //   },
      //   error: (err: any) => {},
      // });

      this.dataService
        .postRequest(payload, CONFIG.API2.DYNAMIC_FILTER)
        .then((res) => {
          let available_keys = res['available_keys'];
          let disabled_keys = onClose ? [] : res['disabled_keys'][0];
          Object.keys(disabled_keys).forEach((item) => {
            available_keys[item] = available_keys[item].concat(
              disabled_keys[item],
            );
          });
          this.columnFilters = cloneDeep(available_keys);
          console.log('columnFilters2', this.columnFilters);
          // this.prev_selected_filters = this.appliedFilters
          this.dynamicFilterLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // console.log("columnFiltersbool",this.prev_selected_filters[this.selectedFilterColumn].length !==this.appliedFilters[this.selectedFilterColumn].length)
      // console.log("columnFilters prev_selected",this.prev_selected_filters[this.selectedFilterColumn])
      // console.log("columnFilters appliedFilters",this.appliedFilters[this.selectedFilterColumn])
      // console.log("column-selectedFilterColumn",this.selectedFilterColumn)
      if (
        this.selectedFilterColumn &&
        this.prev_selected_filters[this.selectedFilterColumn].length !==
          this.appliedFilters[this.selectedFilterColumn].length
      ) {
        this.columnFilters = cloneDeep(this.actualColumnfilters);
        this.availableKeys = Object.keys(this.columnFilters).filter(
          (key) => !keysNotToInvlove.includes(key),
        );
        if (this.appliedFilters[this.selectedFilterColumn] > 0) {
          this.columnFilters[this.selectedFilterColumn].filter((item: any) => {
            this.appliedFilters[this.selectedFilterColumn].includes(item);
          });
        } else {
          this.columnFilters[this.selectedFilterColumn] = cloneDeep(
            this.actualColumnfilters[this.selectedFilterColumn],
          );
        }
        this.filter_details[this.selectedFilterColumn] = cloneDeep(
          this.appliedFilters[this.selectedFilterColumn],
        );
        payload = {
          filter_details: {
            available_keys: this.availableKeys,
            ...this.filter_details,
          },
          // scenarioName: this.baseScenarioName,
          child_scenario_name: this.childScenarioName,
          base_scenario_name: this.baseScenarioName,

          source: 'child-scenario',
        };
        // this.priceScenarioService.dynamicFilter(payload).subscribe({
        //   next: (res: any) => {
        // let available_keys = res["available_keys"];
        // let disabled_keys = onClose ? [] : res["disabled_keys"][0];
        // Object.keys(disabled_keys).forEach((item) => {
        //   available_keys[item] = available_keys[item].concat(
        //     disabled_keys[item]
        //   );
        // });
        // this.columnFilters = cloneDeep(available_keys);
        // console.log("columnFilters2", this.columnFilters);
        // this.prev_selected_filters = cloneDeep(this.appliedFilters);
        // this.dynamicFilterLoading = false;
        //   },
        //   error: (err: any) => {},
        // });
        this.dataService
          .postRequest(payload, CONFIG.API2.DYNAMIC_FILTER)
          .then((res) => {
            let available_keys = res['available_keys'];
            let disabled_keys = onClose ? [] : res['disabled_keys'][0];
            Object.keys(disabled_keys).forEach((item) => {
              available_keys[item] = available_keys[item].concat(
                disabled_keys[item],
              );
            });
            this.columnFilters = cloneDeep(available_keys);
            console.log('columnFilters2', this.columnFilters);
            this.prev_selected_filters = cloneDeep(this.appliedFilters);
            this.dynamicFilterLoading = false;
          })
          .catch((error) => {
            console.log(error);
          });
        // this.priceScenarioService.dynamicFilter2()
      } else {
        this.dynamicFilterLoading = false;
      }
    }
  }
  filterData() {
    let data = cloneDeep(this.actualRowData);
    //console.log(
    //"****************************************************************",
    //this.actualRowData
    //);
    // console.log("filterData",data);
    // console.log("filterData",this.getAppliedFilters());
    console.log('filterData:  ', this.appliedFilters);

    if (this.getAppliedFilters().length !== 0) {
      console.log('filterData:  keys', Object.keys(this.appliedFilters));

      Object.keys(this.appliedFilters).forEach((fil) => {
        //  console.log("in filterdata", fil);
        if (fil != 'scenario_price' && fil != 'percent_change') {
          data = data.filter((row: any) =>
            this.appliedFilters[fil].includes(row[fil]),
          );
          console.log('filterData', data);
        }
      });
    }
    // console.log("filterData",data);

    this.childScenarioTableData = data;
    this.dataSource.data = data;
    var filteredIndexes = [];
    for (var i = 0; i < this.childScenarioTableData.length; i++) {
      filteredIndexes.push(this.childScenarioTableData[i]['id']);
    }
    this.filteredArray = cloneDeep(filteredIndexes);
    console.log('this.filteredArry', this.filteredArray);
    // console.log("rowdata", this.childScenarioTableData);
  }

  searchedTextOfTable: any;
  toggleAllSelectFilter(event: any) {
    this.undoStack.push({
      childScenarioTableData: cloneDeep(this.childScenarioTableData),
      updatedRows: cloneDeep(this.updatedRows),
      actualRowData: cloneDeep(this.actualRowData),
      allSelected: cloneDeep(this.allSelected),
      appliedFilters: cloneDeep(this.appliedFilters),
      previousSelected: cloneDeep(this.prev_selected_filters),
      inflation: cloneDeep(this.inflation),
      demoniation: cloneDeep(this.demoniation),
    });
    console.log('columnFilters toggle', this.columnFilters);
    // this.columnFilters = cloneDeep(this.actualColumnfilters);
    event.stopPropagation();
    console.log(
      'this.columnFilters',
      this.allSelected[this.selectedFilterColumn],
    );
    this.allSelected[this.selectedFilterColumn] =
      !this.allSelected[this.selectedFilterColumn];
    if (this.allSelected[this.selectedFilterColumn]) {
      this.appliedFilters[this.selectedFilterColumn] = cloneDeep(
        this.actualColumnfilters[this.selectedFilterColumn],
      );
    } else {
      this.appliedFilters[this.selectedFilterColumn] = [];
      if (this.searchedTextOfTable) {
        this.columnFilters[this.selectedFilterColumn] = this.columnFilters[
          this.selectedFilterColumn
        ].filter((fil: any) =>
          isNaN(this.searchedTextOfTable)
            ? fil.toLowerCase().includes(this.searchedTextOfTable.toLowerCase())
            : fil.toString().includes(this.searchedTextOfTable.toString()),
        );
      } else {
        this.appliedFilters[this.selectedFilterColumn] = [];
      }
    }
    console.log('columnFilters', this.columnFilters);
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.childScenarioTableData);
      this.dataSource.paginator = this.paginator;
    }, 0);
    this.filterData();
  }

  filterColumnValues(event: any, searchText: any) {
    this.searchedTextOfTable = searchText;
    event.stopPropagation();
    if (!searchText) {
      this.columnFilters[this.selectedFilterColumn] = cloneDeep(
        this.actualColumnfilters[this.selectedFilterColumn],
      );
      console.log(
        'column Filters',
        this.columnFilters[this.selectedFilterColumn],
      );
    }
    this.columnFilters[this.selectedFilterColumn] = this.actualColumnfilters[
      this.selectedFilterColumn
    ].filter((fil: any) =>
      isNaN(searchText)
        ? fil.toLowerCase().includes(searchText.toLowerCase())
        : fil.toString().includes(searchText.toString()),
    );
  }

  consistencyChecksData() {
    return {
      consistencyData: [],
      dataSummary: [],
    };
  }

  undoStep = () => {
    const last_step = this.undoStack.pop();
    this.redoStack.push({
      childScenarioTableData: cloneDeep(this.childScenarioTableData),
      updatedRows: cloneDeep(this.updatedRows),
      actualRowData: cloneDeep(this.actualRowData),
      allSelected: cloneDeep(this.allSelected),
      appliedFilters: cloneDeep(this.appliedFilters),
      previousSelected: cloneDeep(this.prev_selected_filters),
      inflation: cloneDeep(this.inflation),
      demoniation: cloneDeep(this.demoniation),
    });
    this.childScenarioTableData = cloneDeep(last_step.childScenarioTableData);
    this.updatedRows = cloneDeep(last_step.updatedRows);
    this.actualRowData = cloneDeep(last_step.actualRowData);
    this.allSelected = cloneDeep(last_step.allSelected);
    this.appliedFilters = cloneDeep(last_step.appliedFilters);
    this.prev_selected_filters = cloneDeep(last_step.previousSelected);
    this.dataSource.data = cloneDeep(this.childScenarioTableData);
    this.inflation = cloneDeep(last_step.inflation);
    this.demoniation = cloneDeep(last_step.demoniation);
    // this.changeLevel("Brand");
    this.changeLevel(this.selectedValue);
    this.changeOverAll();
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.childScenarioTableData);
      this.dataSource.paginator = this.paginator;
    }, 0);
  };
  redoStep = () => {
    const last_step = this.redoStack.pop();
    this.undoStack.push({
      childScenarioTableData: cloneDeep(this.childScenarioTableData),
      updatedRows: cloneDeep(this.updatedRows),
      actualRowData: cloneDeep(this.actualRowData),
      allSelected: cloneDeep(this.allSelected),
      appliedFilters: cloneDeep(this.appliedFilters),
      previousSelected: cloneDeep(this.prev_selected_filters),
      inflation: cloneDeep(this.inflation),
      demoniation: cloneDeep(this.demoniation),
    });
    this.childScenarioTableData = cloneDeep(last_step.childScenarioTableData);
    this.updatedRows = cloneDeep(last_step.updatedRows);
    this.actualRowData = cloneDeep(last_step.actualRowData);
    this.allSelected = cloneDeep(last_step.allSelected);
    this.appliedFilters = cloneDeep(last_step.appliedFilters);
    (this.prev_selected_filters = cloneDeep(last_step.previousSelected)),
      (this.dataSource.data = cloneDeep(this.childScenarioTableData));
    this.inflation = cloneDeep(last_step.inflation);
    this.demoniation = cloneDeep(last_step.demoniation);
    // this.filterData()
    //this.changeLevel("Brand");
    this.selectedValue = this.levels[0].value;
    this.changeLevel(this.selectedValue);
    this.selected = this.levels[0].name;
    this.changeOverAll();
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.childScenarioTableData);
      this.dataSource.paginator = this.paginator;
    }, 0);
  };

  getAppliedFilters() {
    //Object.keys(this.appliedFilters).forEach(key => this.appliedFilters[key] === undefined ? delete this.appliedFilters[key] : {});
    //console.log("getAppliedFilters",this.appliedFilters);

    const filterApplied = Object.keys(this.appliedFilters).filter(
      (key) =>
        this.appliedFilters[key].length !==
        this.actualColumnfilters[key].length,
    );
    console.log(filterApplied);
    return filterApplied.map((fil) => this.columnDictionary[fil]);
  }

  closeFilterLevel(filter: any) {
    this.undoStack.push({
      childScenarioTableData: cloneDeep(this.childScenarioTableData),
      updatedRows: cloneDeep(this.updatedRows),
      actualRowData: cloneDeep(this.actualRowData),
      allSelected: cloneDeep(this.allSelected),
      appliedFilters: cloneDeep(this.appliedFilters),
      previousSelected: cloneDeep(this.prev_selected_filters),
      inflation: cloneDeep(this.inflation),
      demoniation: cloneDeep(this.demoniation),
    });
    // console.log("onClose", this.appliedFilters);
    // console.log("onClosea", this.actualColumnfilters);
    this.prev_selected_filters = cloneDeep(this.appliedFilters);
    this.allSelected[this.conversionDictionary[filter]] = true;
    this.appliedFilters[this.conversionDictionary[filter]] = cloneDeep(
      this.actualColumnfilters[this.conversionDictionary[filter]],
    );
    // console.log("afteronClose", this.appliedFilters);

    this.dynamicFilter(true, this.conversionDictionary[filter]);
    this.filterData();
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.childScenarioTableData);
      this.dataSource.paginator = this.paginator;
    }, 0);
  }
  getUndoStackSize() {
    return this.undoStack.length;
  }
  /////////////////////////////////////////
  setTableResize(tableWidth: number) {
    let totWidth = 0;
    this.columns.forEach((column) => {
      totWidth += column.width;
    });
    const scale = (tableWidth - 5) / totWidth;
    this.columns.forEach((column) => {
      column.width *= scale;
      this.setColumnWidth(column);
    });
  }
  setDisplayedColumns() {
    this.columns.forEach((column, index) => {
      column.index = index;
      this.displayedColumns[index] = column.field;
    });
  }
  fileUpload(event) {
    const file = event.target.files[0];

    if (file) {
      this.parseCsv(file);
    }
  }
  compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((element, i) => element === arr2[i]);
  }

  allBaseUnitsNonZero(list) {
    return list.every((item) => item.Base_Units !== 0);
  }
  compareStringLists(list1, list2) {
    if (list1.length !== list2.length) {
      return false;
    }

    for (let i = 0; i < list1.length; i++) {
      if (list1[i] !== list2[i]) {
        return false;
      }
    }

    return true;
  }
  uploadedCsvJsonData;
  uploadedCsvCols;
  parseCsv(file: File) {
    this.papa.parse(file, {
      complete: (result) => {
        // Handle the parsed CSV data (result.data) as needed
        console.log('Parsed CSV:', result.data);
        // Access column names
        result.data = result.data.filter((obj) => {
          if (this.baseDetails['price'] == PRICE_CHANGE_MAPPER.POST_CODE_PLAN) {
            obj[STATIC_KEYS.RETAILER] = obj[REGION_LEADER];
            delete obj[REGION_LEADER];
          }

          if (obj[STATIC_KEYS.RETAILER]) {
            return obj;
          }
        });
        let columns = result.meta.fields;
        columns = columns.map((col) => {
          if (col === REGION_LEADER) {
            return STATIC_KEYS.RETAILER;
          }
          return col;
        });
        this.uploadedCsvJsonData = cloneDeep(result.data);
        this.uploadedCsvCols = cloneDeep(columns);

        // Do something with the column names
        console.log('Columns:', columns);
        // let temp = requiredStruc(result.data)

        let retalilerlist = this.findUniqueRetailers(this.uploadedCsvJsonData);
        let retalerCheck = {
          name: 'Retailer Check',
          check: this.compareStringLists(retalilerlist, this.retailerListOrg),
        };
        let allcolsFilled = true;
        let basePriceLesthanZero = true;
        let periodCheck = this.compareArrays(
          [...columns.slice(PERIOD_COLS_INDEX)],
          [...this.columnData.slice(PERIOD_COLS_INDEX)],
        );

        result.data.forEach((row) => {
          Object.values(row).forEach((value: any) => {
            if (value === undefined || value.trim() === '') {
              console.log(row);
              console.log(value);
              allcolsFilled = false;
            }
          });
          if (
            row[STATIC_KEYS.BASE_PRICE] == 0 ||
            row[STATIC_KEYS.BASE_PRICE] < 0
          ) {
            basePriceLesthanZero = false;
          }
        });
        let numericColumns = [
          STATIC_KEYS.BASE_PRICE,
          STATIC_KEYS.VOLUME,
          ...columns.slice(PERIOD_COLS_INDEX),
        ];

        let nonZeroSale = {
          name: 'Non Zero sales in all time periods',
          check: this.allBaseUnitsNonZero(this.uploadedCsvJsonData),
        };
        const hasNonNumeric = !this.checkJSONForNonNumeric(
          result.data,
          numericColumns,
        );
        let periodCheckObj = { name: 'Time Period Check', check: periodCheck };
        let blankVals = { name: 'All Columns filled', check: allcolsFilled };
        let basePriceLesthanZeroObj = {
          name: 'Base Price should be greater than 0',
          check: basePriceLesthanZero,
        };
        let hasNumericObj = {
          name: 'Period price, Base_Price and Base_Units columns should contain numeric values',
          check: hasNonNumeric,
        };
        let checks = [
          blankVals,
          nonZeroSale,
          retalerCheck,
          periodCheckObj,
          basePriceLesthanZeroObj,
          hasNumericObj,
        ];

        this.openDialog({
          consistencyChecksData: checks,
          syncCsvDataWithTool: this.syncCsvDataWithTool.bind(this),
        });
      },
      header: true, // Set to true if your CSV file has headers
    });
  }

  syncCsvDataWithTool() {
    this.childScenarioTableData = this.csvJsonToTableRequiredStrucConversion(
      this.uploadedCsvJsonData,
      this.uploadedCsvCols.slice(PERIOD_COLS_INDEX),
    );
    for (let i = 0; i < this.childScenarioTableData.length; i++) {
      this.childScenarioTableData[i]['id'] = i;
    }
    this.actualRowData = cloneDeep(this.childScenarioTableData);
    this.dataSource.data = this.childScenarioTableData;
    this.permanentData = cloneDeep(this.childScenarioTableData);
    this.changeLevel(this.selectedValue);
    Swal.fire({
      icon: 'success',
      html: 'Base data loaded successfully.',
      showConfirmButton: false,
      timer: 2000,
    });
  }

  private hasNonNumericValues(jsonData: any[], columnName: string): boolean {
    return jsonData.some((row) => isNaN(Number(row[columnName])));
  }

  checkJSONForNonNumeric(jsonData: any[], numericColumns: any[]): boolean {
    try {
      for (const columnName of numericColumns) {
        if (!jsonData[0]?.hasOwnProperty(columnName)) {
          console.error(`Property "${columnName}" not found in JSON data.`);
          return false;
        }

        if (this.hasNonNumericValues(jsonData, columnName)) {
          return true; // Return true if non-numeric values are found in any specified column
        }
      }

      return false; // Return false if no non-numeric values are found in any specified column
    } catch (error) {
      console.error('Error checking JSON for non-numeric values:', error);
      return false;
    }
  }

  csvJsonToTableRequiredStrucConversion(existingStruc, columns) {
    let requiredStruc = [];
    existingStruc.forEach((item) => {
      let convertedItem = {
        [STATIC_KEYS.RETAILER]: item[STATIC_KEYS.RETAILER],
        // [STATIC_KEYS.CATEGORY]: item[STATIC_KEYS.CATEGORY],
        [STATIC_KEYS.BRAND_PACK_VARIANT]: item[STATIC_KEYS.BRAND_PACK_VARIANT],
        [STATIC_KEYS.PRICE_SECTOR]: item[STATIC_KEYS.PRICE_SECTOR],
        [STATIC_KEYS.TAR_LEVEL]: item[STATIC_KEYS.TAR_LEVEL],
        [STATIC_KEYS.BRAND_HOUSE]: item[STATIC_KEYS.BRAND_HOUSE],
        [STATIC_KEYS.BASE_PRICE]: parseFloat(item[STATIC_KEYS.BASE_PRICE]),
        [STATIC_KEYS.MANFACTURER]: item[STATIC_KEYS.MANFACTURER],
        [STATIC_KEYS.LENGTH_BAND]: item[STATIC_KEYS.LENGTH_BAND],
        [STATIC_KEYS.PACK_CONTENTS]: item[STATIC_KEYS.PACK_CONTENTS],
        [STATIC_KEYS.VOLUME]: item[STATIC_KEYS.VOLUME],
        [STATIC_KEYS.BRAND_VARIANT]: item[STATIC_KEYS.BRAND_VARIANT],
        [PERIOD_DATA]: {},
      };

      columns.map((col) => {
        const [year, period] = col.split(this.periodMapper[this.periodType]);
        if (!convertedItem[PERIOD_DATA][year]) {
          convertedItem[PERIOD_DATA][year] = [];
        }
        convertedItem[PERIOD_DATA][year].push({
          [period]: parseFloat(item[col]),
        });
      });
      // Object.keys(item).forEach(key => {
      //     if (key.startsWith("202")) {
      //         const [year, week] = key.split('-W');
      //         if (!convertedItem.period_data[year]) {
      //             convertedItem.period_data[year] = [];
      //         }
      //         convertedItem.period_data[year].push({
      //             [week]: parseFloat(item[key])
      //         });
      //     }
      // });

      requiredStruc.push(convertedItem);
    });
    return requiredStruc;
  }
  onResizeColumn(event: any, index: number) {
    this.checkResizing(event, index);
    this.currentResizeIndex = index;
    this.pressed = true;
    this.startX = event.pageX;
    this.startWidth = event.target.parentElement.clientWidth;
    event.preventDefault();
    this.mouseMove(index);
  }
  private checkResizing(event: any, index: any) {
    const cellData = this.getCellData(index);
    if (
      index === 0 ||
      (Math.abs(event.pageX - cellData.right) < cellData.width / 2 &&
        index !== this.columns.length - 1)
    ) {
      this.isResizingRight = true;
    } else {
      this.isResizingRight = false;
    }
  }

  private getCellData(index: number) {
    const headerRow =
      this.matTableRef.nativeElement.children[0].querySelector('tr');
    const cell = headerRow.children[index];
    // console.log(cell)
    return cell.getBoundingClientRect();
  }

  mouseMove(index: number) {
    this.resizableMousemove = this.renderer.listen(
      'document',
      'mousemove',
      (event: any) => {
        // console.log("invoking")
        if (this.pressed && event.buttons) {
          const dx = this.isResizingRight
            ? event.pageX - this.startX
            : -event.pageX + this.startX;
          const width = this.startWidth + dx;
          // console.log(width,this.startWidth)
          if (this.currentResizeIndex === index && width > 50) {
            // console.log("need to change")
            this.setColumnWidthChanges(index, width);
          }
        }
      },
    );
    this.resizableMouseup = this.renderer.listen(
      'document',
      'mouseup',
      (event: any) => {
        if (this.pressed) {
          this.pressed = false;
          this.currentResizeIndex = -1;
        }
      },
    );
  }

  setColumnWidthChanges(index: number, width: number) {
    const orgWidth = this.columns[index].width;
    const dx = width - parseInt(orgWidth);
    if (dx !== 0) {
      const j = this.isResizingRight ? index + 1 : index - 1;
      const newWidth = parseInt(this.columns[j].width) - dx;
      if (newWidth > 50) {
        this.columns[index].width = width;
        this.setColumnWidth(this.columns[index]);
        this.columns[j].width = newWidth;
        this.setColumnWidth(this.columns[j]);
      }
    }
  }

  setColumnWidth(column: any) {
    const columnEls = Array.from(
      document.getElementsByClassName('mat-column-' + column.field),
    );
    columnEls.forEach((el: any) => {
      el.style.width = column.width + 'px';
    });
  }

  toCapitalize(key: any) {
    let keyArray = key.split('_');
    let capitalKeyArray = keyArray.map((el: any) => {
      return el.charAt(0).toUpperCase() + el.slice(1);
    });
    //console.log(capitalKeyArray)
    return capitalKeyArray.join(' ');
  }
  resetData() {
    this.absolute = 0;
    this.percent = 0;
    this.undoStack.push({
      childScenarioTableData: cloneDeep(this.childScenarioTableData),
      updatedRows: cloneDeep(this.updatedRows),
      actualRowData: cloneDeep(this.actualRowData),
      allSelected: cloneDeep(this.allSelected),
      appliedFilters: cloneDeep(this.appliedFilters),
      previousSelected: cloneDeep(this.prev_selected_filters),
      inflation: cloneDeep(this.inflation),
      demoniation: cloneDeep(this.demoniation),
    });
    this.updatedRows = [];
    this.childScenarioTableData = [];
    this.filteredArray = [];
    this.childScenarioTableData = cloneDeep(this.permanentData);
    // this.actualRowData = cloneDeep(this.permanentData);
    // for (let i = 0; i < this.childScenarioTableData.length; i++) {
    //   this.childScenarioTableData[i]["id"] = i
    //   this.filteredArray.push(i)
    //   this.childScenarioTableData[i]["volume"] =
    //     Math.round(this.childScenarioTableData[i]["volume"] * 10) / 10
    //   if (
    //     this.childScenarioTableData[i]["scenario_price"] !==
    //     this.childScenarioTableData[i][this.KEYS_OF_CSV.BASE_PRICE]
    //   ) {
    //     this.updatedRows.push(i)
    //   }
    //   // this.childScenarioTableData[i]["next_price"] = dataCalculation;
    //   this.childScenarioTableData[i]["percent_change"] =
    //     Math.round(this.childScenarioTableData[i]["percent_change"] * 10) / 10
    //   // this.permanentData[i]["next_price"] = dataCalculation;

    //   this.scenarioP.push(this.childScenarioTableData[i]["scenario_price"])
    // }
    this.actualRowData = cloneDeep(this.childScenarioTableData);
    console.log('columnFilters', this.getAppliedFilters());
    if (this.getAppliedFilters().length > 0) {
      this.getAppliedFilters().forEach((filter) => {
        this.closeFilterLevel(filter);
      });
    }
    this.appliedFilters = cloneDeep(this.actualColumnfilters);
    this.columnFilters = cloneDeep(this.actualColumnfilters);
    this.dynamicFilter(false);
    setTimeout(() => {
      this.dataSource = new MatTableDataSource(this.childScenarioTableData);
      this.dataSource.paginator = this.paginator;
      this.changeLevel(this.selectedValue);
      this.changeOverAll();
    }, 0);
  }
  openPopUp() {
    // const dialogRef = this.dialog.open(PopupComponent, {
    //   height: "80%",
    //   width: "90%",
    //   data: {
    //     levels: this.levels,
    //     childScenarioTableData: this.childScenarioTableData,
    //     actualRowData: this.actualRowData,
    //     selectedValue: this.selectedValue,
    //     selectedName: this.selected,
    //   },
    // });
  }

  onOptionSelect(option: string) {
    this.selectedOption = option;
  }

  onDownload(): void {
    if (this.selectedOption === 'New Product Launch') {
      this.downloadTemplateForNewProduct();
    } else if (this.selectedOption === 'Pack Upsize/Downsize') {
      this.onDownloadPackUpsizeDownsize('PackUpsizeDownsizeTemplate.csv');
    } else if (this.selectedOption === 'Pack Merger') {
      this.onDownloadPackUpsizeDownsize('PackMergerTemplate.csv');
    } else if (this.selectedOption === 'Pack Split') {
      this.onDownloadPackUpsizeDownsize('PackSplit.csv', true);
    }
  }

  onFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      if (this.selectedOption === 'New Product Launch') {
        this.createNewPack(file);
      } else if (this.selectedOption === 'Pack Upsize/Downsize') {
        this.onFileUploadPackChange(
          file,
          CONFIG.API2.UPLOAD_MODIFIED_PACK_UPSIZE_DOWNSIZE,
          this.selectedOption,
        );
      } else if (this.selectedOption === 'Pack Merger') {
        this.onFileUploadPackChange(
          file,
          CONFIG.API2.UPLOAD_PACK_MERGER,
          this.selectedOption,
        );
      } else if (this.selectedOption === 'Pack Split') {
        this.onFileUploadPackChange(
          file,
          CONFIG.API2.UPLOAD_PACK_SPLIT,
          this.selectedOption,
        );
      }
    }
    input.value = '';
  }

  downloadTemplateForNewProduct() {
    this.isDownloadLoading = true;
    const payload = {
      user_selected_value: this.selectedOption,
    };
    this.dataService
      .postRequest(payload, CONFIG.API2.DOWNLOAD_TEMPLATE_FOR_NEW_PRODUCT)
      .then((res: any) => {
        this.downloadExcelForNewPackLaunch(res);
        this.downloaded = true;
        this.loading = false;
        this.isDownloadLoading = false;
      })
      .catch((err) => {
        console.error('Error downloading template:', err);
        this.isDownloadLoading = false;
        Swal.fire({
          text: 'Error downloading template',
          icon: 'error',
          confirmButtonColor: '#d31346',
          confirmButtonText: 'OK',
        });
      });
  }

  downloadCsv(csvContent: string, filename: string) {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  onDownloadPackUpsizeDownsize(
    fileName: string,
    changeContent?: boolean,
  ): void {
    this.isDownloadLoading = true;
    this.dataService
      .getRequestWithJsonData(
        CONFIG.API2.DOWNLOAD_TEMPLATE_FOR_PACK_UPSIZE_DOWNSIZE,
      )
      .then((res: any) => {
        let content = res.data;
        if (changeContent) {
          content = res.data.map((ele) => {
            delete ele['Updated PackSize'];
            delete ele['Updated Base_Price'];
            return {
              ...ele,
              'Updated PackSize1': '',
              'Updated PackSize2': '',
              'Price per Pack1': '',
              'Price per Pack2': '',
            };
          });
        }
        this.downloadedFileContent = content;
        const csvContent = this.papa.unparse(content, {
          header: true,
        });
        this.downloadCsv(csvContent, fileName);
        this.isDownloadLoading = false;
        this.downloaded = true;
      })
      .catch((err) => {
        console.error('Error downloading file:', err);
        Swal.fire({
          text: 'Error downloading file',
          icon: 'error',
          confirmButtonColor: '#d31346',
          confirmButtonText: 'OK',
        });
        this.isDownloadLoading = false;
      });
  }

  downloadExcelForNewPackLaunch(response: any) {
    const ws1: XLSX.WorkSheet = this.createWorksheetWithMandatoryOptional(
      response.data,
    );
    const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      response.agg_input_file,
    );

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws1, 'NewProductLaunchTemplate');
    XLSX.utils.book_append_sheet(wb, ws2, 'InputFile');

    const wbout: ArrayBuffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
    });
    const blob: Blob = new Blob([wbout], { type: 'application/octet-stream' });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'NewProductLaunchTemplate.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  convertJsonToArray(jsonData: any): any[] {
    const keys = Object.keys(jsonData);
    return keys.map((key) => ({ key, value: jsonData[key] }));
  }

  createWorksheetWithMandatoryOptional(jsonData: any): XLSX.WorkSheet {
    const columns = Object.keys(jsonData);

    const mandatoryOptionalRow = columns.map((column) =>
      jsonData[column][0] === true ? 'Mandatory' : 'Optional',
    );

    const headerRow = columns;

    const worksheetData = [mandatoryOptionalRow, headerRow];

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(worksheetData);

    return ws;
  }

  createNewPack(file: Blob) {
    this.isUploadLoading = true;

    const reader = new FileReader();
    reader.onload = (event: any) => {
      // const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(event.target.result, { type: 'array' });

      const metadataSheetName = 'NewProductLaunchTemplate';
      const metadataSheet = workbook.Sheets[metadataSheetName];

      if (!metadataSheet) {
        this.isUploadLoading = false;
        Swal.fire({
          text: 'NewProductLaunchTemplate sheet not found!',
          icon: 'error',
          confirmButtonColor: '#d31346',
          confirmButtonText: 'OK',
        });
        return;
      }

      const metadataJson: any = XLSX.utils.sheet_to_json(metadataSheet, {
        defval: null,
        range: 1,
      });

      const payload = {
        input_file: metadataJson,
        user_input: this.selectedOption,
      };

      this.dataService
        .postRequest(payload, CONFIG.API2.UPLOAD_TEMPLATE_FOR_NEW_PACK)
        .then((res) => {
          this.loading = false;
          Swal.fire({
            icon: 'success',
            text: 'File uploaded successfully!',
            showConfirmButton: false,
            timer: 2000,
          });
          this.isFileUpload = true;
          this.isUploadLoading = false;
          this.downloaded = false;
          this.ngOnInit();
        })
        .catch((err) => {
          this.loading = false;
          this.isUploadLoading = false;
          console.error('Error uploading file:', err);
          Swal.fire({
            text: 'Error uploading file',
            icon: 'error',
            confirmButtonColor: '#d31346',
            confirmButtonText: 'OK',
          });
        });
    };

    reader.readAsArrayBuffer(file);
  }

  // getUpdatedRows(
  //   originalData: any[],
  //   modifiedData: any[],
  //   packCase: string,
  // ): any[] {
  //   const updatedRows: any[] = [];

  //   const normalizeValue = (value: any) => {
  //     if (
  //       !isNaN(value) &&
  //       value !== null &&
  //       value !== undefined &&
  //       value !== ''
  //     ) {
  //       return parseFloat(value);
  //     }
  //     return value;
  //   };

  //   const areValuesEqual = (
  //     originalValue: any,
  //     modifiedValue: any,
  //     tolerance: number = 1e-3,
  //   ) => {
  //     if (
  //       typeof originalValue === 'number' &&
  //       typeof modifiedValue === 'number'
  //     ) {
  //       return Math.abs(originalValue - modifiedValue) < tolerance;
  //     }
  //     return originalValue === modifiedValue;
  //   };

  //   if (modifiedData.length > originalData.length) {
  //     throw new Error('New rows have been added. Adding rows is not allowed.');
  //   }

  //   for (let i = 0; i < originalData.length; i++) {
  //     const originalRow = originalData[i];
  //     const modifiedRow = modifiedData[i];

  //     if (!modifiedRow) {
  //       throw new Error(
  //         'A row has been deleted from the original data. Please ensure all rows are present.',
  //       );
  //     }

  //     let rowChanged = false;
  //     const updatedRow: any = {};

  //     for (const key in originalRow) {
  //       if (originalRow.hasOwnProperty(key)) {
  //         const originalValue = normalizeValue(originalRow[key]);
  //         const modifiedValue = normalizeValue(modifiedRow[key]);

  //         if (
  //           key !== 'Updated PackSize' &&
  //           key !== 'Base_Price' &&
  //           !areValuesEqual(originalValue, modifiedValue)
  //         ) {
  //           console.log('CHANGED VALUE', originalValue, modifiedValue);
  //           throw new Error(
  //             `Only the "Updated PackSize or Base_Price" column can be modified. Changes detected in column: ${key}.`,
  //           );
  //         }

  //         if (
  //           (key === 'Updated PackSize' || key === 'Base_Price') &&
  //           !areValuesEqual(originalValue, modifiedValue)
  //         ) {
  //           rowChanged = true;
  //         }

  //         updatedRow[key] = modifiedValue;
  //       }
  //     }

  //     if (rowChanged) {
  //       updatedRows.push(updatedRow);
  //     }
  //   }

  //   // Check if there are any empty updated rows (i.e., rows with no changes)
  //   if (updatedRows.length === 0) {
  //     throw new Error(
  //       'No changes detected or row deletion detected. Please review your data.',
  //     );
  //   }

  //   return updatedRows;
  // }

  getUpdatedRows(
    originalData: any[],
    modifiedData: any[],
    packCase: string,
  ): any[] {
    const updatedRows: any[] = [];

    const allowedColumns =
      packCase === 'Pack Upsize/Downsize'
        ? ['Updated PackSize', 'Updated Base_Price']
        : packCase === 'Pack Merger'
          ? ['Updated PackSize', 'Updated Base_Price']
          : [
              'Updated PackSize1',
              'Updated PackSize2',
              'Price per Pack1',
              'Price per Pack2',
            ];

    const normalizeValue = (value: any) => {
      if (
        !isNaN(value) &&
        value !== null &&
        value !== undefined &&
        value !== ''
      ) {
        return parseFloat(value);
      }
      return value;
    };

    const areValuesEqual = (
      originalValue: any,
      modifiedValue: any,
      tolerance: number = 1e-3,
    ) => {
      if (
        typeof originalValue === 'number' &&
        typeof modifiedValue === 'number'
      ) {
        return Math.abs(originalValue - modifiedValue) < tolerance;
      }
      return originalValue === modifiedValue;
    };

    if (modifiedData.length > originalData.length) {
      throw new Error('New rows have been added. Adding rows is not allowed.');
    }

    for (let i = 0; i < originalData.length; i++) {
      const originalRow = originalData[i];
      const modifiedRow = modifiedData[i];

      if (!modifiedRow) {
        throw new Error(
          'A row has been deleted from the original data. Please ensure all rows are present.',
        );
      }

      let rowChanged = false;
      const updatedRow: any = {};

      for (const key in originalRow) {
        if (originalRow.hasOwnProperty(key)) {
          const originalValue = normalizeValue(originalRow[key]);
          const modifiedValue = normalizeValue(modifiedRow[key]);

          if (
            !allowedColumns.includes(key) &&
            !areValuesEqual(originalValue, modifiedValue)
          ) {
            throw new Error(
              `Only the columns ${allowedColumns.join(' , ')} can be modified. Changes detected in column: ${key}.`,
            );
          }

          if (
            allowedColumns.includes(key) &&
            !areValuesEqual(originalValue, modifiedValue)
          ) {
            rowChanged = true;
          }

          updatedRow[key] = modifiedValue;
        }
      }

      if (rowChanged) {
        updatedRows.push(updatedRow);
      }
    }

    if (updatedRows.length === 0) {
      throw new Error(
        'No changes detected or row deletion detected. Please review your data.',
      );
    }

    return updatedRows;
  }

  onFileUploadPackChange(file: Blob, endpoint: string, packCase: string): void {
    const reader = new FileReader();
    reader.onload = () => {
      const uploadedFileContent = reader.result as string;

      const parsedUploadedData = this.papa.parse(uploadedFileContent, {
        header: true,
        skipEmptyLines: true,
      }).data;

      try {
        const updatedRows = this.getUpdatedRows(
          this.downloadedFileContent,
          parsedUploadedData,
          packCase,
        );

        const payload = {
          user_inputs: updatedRows,
        };

        this.isUploadLoading = true;

        this.dataService
          .postRequest(payload, endpoint)
          .then((res) => {
            this.loading = false;
            Swal.fire({
              icon: 'success',
              text: 'File uploaded successfully!',
              showConfirmButton: false,
              timer: 2000,
            });
            this.isUploadLoading = false;
            this.isFileUpload = true;
            this.ngOnInit();
            this.downloaded = false;
          })
          .catch((err) => {
            this.loading = false;
            this.isUploadLoading = false;
            console.error('Error uploading file:', err);
            Swal.fire({
              text: 'Error uploading file',
              icon: 'error',
              confirmButtonColor: '#d31346',
              confirmButtonText: 'OK',
            });
          });
      } catch (error) {
        Swal.fire({
          text: error.message,
          icon: 'warning',
          confirmButtonColor: '#d31346',
          confirmButtonText: 'OK',
        });
        this.isUploadLoading = false;
      }
    };
    reader.readAsText(file); // Read the file content as text
  }
}
